import React from 'react';
import { connect } from 'react-redux';
import dataModel from '../../../models/DataModel';
import BaseComponent from '../../../baseClasses/BaseComponent';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import './MobileOfflineBanner.scss';

export class MobileOfflineBanner extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      bannerText: 'You are in Offline Mode.',
      retrying: false,
      shown: false,
    };
    this.closeBanner = this.closeBanner.bind(this);

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ shown: true });
    }, 10);
  }

  shouldComponentUpdate(nextProps){
    if(nextProps.online == true){
      this.closeBanner();
    }
    return true;
  }

  closeBanner() {
    return new Promise((resolve) => {
      // wait for animation to actually close banner
      setTimeout(() => {
        this.setState({ shown: false });
        resolve();
        // hide the component
        this.props.dataModel.hideGlobalBanner(this.props.bannerType);
        // window.location.reload()
      }, 150);
    });
  }

  handleRefresh(){
    this.setState({ 
      retrying: true,
      bannerText: 'Reconnecting...',
    });
    setTimeout(() => {
      if(!dataModel.isOffline){
        this.props.dataModel.notifyConnectionStatusChanged(!dataModel.isOffline);
        this.closeBanner();
        // window.location.reload()
      }
      else{
        this.setState({
          retrying: false,
          bannerText: 'You are in Offline Mode.',
        });
      }
      this.analyticsLogger.logOfflineMode('OfflineModeManualRetry');
    }, 3000);

  }
  
  render() {

    return (
      <div className={'offline-banner ' + (this.state.shown ? '' : 'offline-banner--closing')}>
        <div className='offline-banner__text'>{this.state.bannerText}</div>
        { !this.state.retrying && 
          <div className='offline-banner__retry' onClick={this.handleRefresh}>Retry Connection.</div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    dataModel: dataModel,
    online: state.main.online,
  };
};

export default connect(mapStateToProps)(MobileOfflineBanner);



// WEBPACK FOOTER //
// ./src/components/banners/MobileOfflineBanner/index.js